import { render } from "./YourDetailsML1.vue?vue&type=template&id=89a6b79c&scoped=true"
import script from "./YourDetailsML1.vue?vue&type=script&lang=js"
export * from "./YourDetailsML1.vue?vue&type=script&lang=js"

import "./YourDetailsML1.vue?vue&type=style&index=0&id=89a6b79c&lang=scss"
import "./YourDetailsML1.vue?vue&type=style&index=1&id=89a6b79c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a6b79c"]])

export default __exports__